import { render, staticRenderFns } from "./GuestsDeleteInvite.vue?vue&type=template&id=22a76d70&scoped=true&"
import script from "./GuestsDeleteInvite.vue?vue&type=script&lang=js&"
export * from "./GuestsDeleteInvite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a76d70",
  null
  
)

export default component.exports